import { defineMessages } from 'react-intl';

const messages = defineMessages({
  cardTitle: {
    id: 'App.ApplicationProfile.Waitlist.cardTitle',
    defaultMessage: 'Waitlist Summary',
  },
  householdInformation: {
    id: 'App.ApplicationProfile.Waitlist.householdInformation',
    defaultMessage: 'Household Information',
  },
  edit: {
    id: 'App.ApplicationProfile.Waitlist.edit',
    defaultMessage: 'Edit',
  },
  submissionDate: {
    id: 'App.ApplicationProfile.Waitlist.submissionDate',
    defaultMessage: 'Submission Date:',
  },
  householdIncome: {
    id: 'App.ApplicationProfile.Waitlist.householdIncome',
    defaultMessage: 'Household Income:',
  },
  numberOfAdults: {
    id: 'App.ApplicationProfile.Waitlist.numberOfAdults',
    defaultMessage: 'Number of Adults',
  },
  numberOfMinors: {
    id: 'App.ApplicationProfile.Waitlist.numberOfMinors',
    defaultMessage: 'Number of Minors',
  },
  waitlistPositions: {
    id: 'App.ApplicationProfile.Waitlist.waitlistPositions',
    defaultMessage: 'Waitlist Positions',
  },
  allBedrooms: {
    id: 'App.ApplicationProfile.Waitlist.allBedrooms',
    defaultMessage: 'All Bedrooms',
  },
  selectFromWaitlist: {
    id: 'App.ApplicationProfile.Waitlist.selectFromWaitlist',
    defaultMessage: 'Select from waitlist',
  },
  positionOnWaitlist: {
    id: 'App.ApplicationProfile.Waitlist.positionOnWaitlist',
    defaultMessage: 'Position on Waitlist:',
  },
  notOnWaitlist: {
    id: 'App.ApplicationProfile.Waitlist.notOnWaitlist',
    defaultMessage: 'Not on Waitlist',
  },
  add: {
    id: 'App.ApplicationProfile.Waitlist.add',
    defaultMessage: 'Add',
  },
  addClosedTooltip: {
    id: 'App.ApplicationProfile.Waitlist.addClosedTooltip',
    defaultMessage: 'The waitlist is closed and not accepting applications.',
  },
  deny: {
    id: 'App.ApplicationProfile.Waitlist.deny',
    defaultMessage: 'Deny',
  },
  cancel: {
    id: 'App.ApplicationProfile.Waitlist.cancel',
    defaultMessage: 'Cancel',
  },
  reinstate: {
    id: 'App.ApplicationProfile.Waitlist.reinstate',
    defaultMessage: 'Reinstate',
  },
  incomeLevels: {
    id: 'App.ApplicationProfile.Waitlist.incomeLevels',
    defaultMessage: 'Income Levels',
  },
  preferences: {
    id: 'App.ApplicationProfile.Waitlist.preferences',
    defaultMessage: 'Preferences',
  },
  preferredBedrooms: {
    id: 'App.ApplicationProfile.Waitlist.preferredBedrooms',
    defaultMessage: 'Preferred Bedrooms:',
  },
  preferredFloorplan: {
    id: 'App.ApplicationProfile.Waitlist.preferredFloorplan',
    defaultMessage: 'Preferred Floor Plan:',
  },
  waitlistPreferences: {
    id: 'App.ApplicationProfile.Waitlist.waitlistPreferences',
    defaultMessage: 'Preferences:',
  },
  accommodations: {
    id: 'App.ApplicationProfile.Waitlist.accommodations',
    defaultMessage: 'Accommodations',
  },
  displacement: {
    id: 'App.ApplicationProfile.Waitlist.displacement',
    defaultMessage: 'Displacement',
  },
  accessibleUnit: {
    id: 'App.ApplicationProfile.Waitlist.accessibleUnit',
    defaultMessage: 'Accessible Unit',
  },
  accommodationsRequested: {
    id: 'App.ApplicationProfile.Waitlist.accommodationsRequested',
    defaultMessage: 'Accommodations Requested?',
  },
  yes: {
    id: 'App.ApplicationProfile.Waitlist.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'App.ApplicationProfile.Waitlist.no',
    defaultMessage: 'No',
  },
  positionStatusWaiting: {
    id: 'App.ApplicationProfile.Waitlist.positionStatusWaiting',
    defaultMessage: 'Waiting',
  },
  positionStatusSelected: {
    id: 'App.ApplicationProfile.Waitlist.positionStatusSelected',
    defaultMessage: 'Selected',
  },
  positionStatusHoused: {
    id: 'App.ApplicationProfile.Waitlist.positionStatusHoused',
    defaultMessage: 'Housed',
  },
  positionStatusWithdrawn: {
    id: 'App.ApplicationProfile.Waitlist.positionStatusWithdrawn',
    defaultMessage: 'Withdrawn',
  },
  positionStatusDenied: {
    id: 'App.ApplicationProfile.Waitlist.positionStatusDenied',
    defaultMessage: 'Denied',
  },
  positionStatusCanceled: {
    id: 'App.ApplicationProfile.Waitlist.positionStatusCanceled',
    defaultMessage: 'Canceled',
  },
});

export default messages;
